import React from 'react';
import { BaseAction } from '../../models';
import { ButtonAction } from '../button-action';

interface Props extends BaseAction {}
export const ActionGeneral: React.FC<Props> = ({ onDone, actionKey, isLoading }) => {
  return <ButtonAction actionKey={actionKey} onClick={onDone} disabled={isLoading} />;
};
